<template>
  <el-aside v-if="showMenu || !isMobile" class="aside" :class="{ 'aside--collapsed': isCollapse }">
      <div v-if="!isMobile" class="logo-nav">
        <div class="logo-nav__title">ГРУППА КОМПАНИЙ</div>
        <div class="logo-nav__brand">PETROLEUM<span class="logo-nav__dot">.</span></div>
      </div>
      <div v-if="!isMobile" class="company-switch">
        <div class="company-switch__label">КОМПАНИЯ</div>
        <div class="company-switch__box" :class="{ 'company-switch__box--clickable': isPtc }" @click="isPtc && (companySwitchOpen = !companySwitchOpen)">
          <span class="company-switch__value">{{ activeCompanyLabel }}</span>
          <i class="el-icon-arrow-down"></i>
        </div>
        <div v-if="isPtc && companySwitchOpen" class="company-switch__list">
          <div
              v-for="company in companies"
              :key="company.key"
              class="company-switch__item"
              :class="{ 'company-switch__item--disabled': !company.submenu, 'company-switch__item--active': company.key === activeCompanyKey }"
              @click="selectCompany(company)">
            {{ company.label }}
          </div>
        </div>
      </div>
      <el-menu router ref="sideMenu" class="el-menu-vertical-demo" :collapse="isCollapse" unique-opened @open="handleMenuOpen" @close="handleMenuClose">
        <div class="menu-section-label" v-if="!isCollapse">Сервис</div>
        <el-menu-item v-for="item in menu" :key="item.index" :index="item.index">
          <i :class="item.icon"></i>
          <span slot="title">{{ item.title }}</span>
        </el-menu-item>
        <el-menu-item v-if="isUserTTK || isUserPortocom" index="/company/register?type=reestrVC">
          <i class="el-icon-notebook-2"></i>
          <span slot="title">Реестр с расчетами</span>
        </el-menu-item>
        <div class="menu-section-label" v-if="!isCollapse">Документы</div>
        <el-submenu index="agreement" v-if="canWatchAgreement && !isRolePetroleum">
          <template slot="title">
            <i class="el-icon-tickets"></i>
            <span>Договора</span>
            <span v-if="countForKey('agreement') > 0" class="menu-badge">{{ countForKey('agreement') }}</span>
          </template>
          <el-menu-item index="/company/agreement/agreement/true">
            <i class="el-icon-circle-check"></i>
            <span slot="title">Подписанные</span>
          </el-menu-item>
          <el-menu-item index="/company/agreement/agreement/false">
            <i class="el-icon-circle-close"></i>
            <span slot="title">Не подписанные</span>
          </el-menu-item>
        </el-submenu>
        <el-submenu index="agreement2" v-if="canWatchAgreement && isRolePetroleum">
          <template slot="title">
            <i class="el-icon-tickets"></i>
            <span>Договора</span>
            <span v-if="countForKey('agreement') > 0" class="menu-badge">{{ countForKey('agreement') }}</span>
          </template>
          <el-menu-item index="/company/agreementpet/agreement">
            <i class="el-icon-circle-check"></i>
            <span slot="title">Подписанные</span>
          </el-menu-item>
          <el-menu-item index="/company/agreement/agreement/false">
            <i class="el-icon-circle-close"></i>
            <span slot="title">Не подписанные</span>
          </el-menu-item>
        </el-submenu>
        <el-submenu v-if="isPtc && canWatchDocuments && isActiveCompany('rti')" index="vagonnik">
          <template slot="title">
            <i class="el-icon-office-building"></i>
            <span>Вагонники</span>
          </template>
          <el-submenu index="vagonnik1">
            <template slot="title">
              <i class="el-icon-download"></i>
              <span>Полученные</span>
              <span v-if="!isMenuOpen('vagonnik1') && countForKeys(getDocumentsList('VAGONNIK')) > 0" class="menu-badge">{{ countForKeys(getDocumentsList('VAGONNIK')) }}</span>
            </template>
            <el-menu-item-group>
              <el-menu-item :index="`/company/documents/${getDocumentsList('VAGONNIK').map(item => item.key).toString()}?bin=19114002534511&all=1`"><i class="el-icon-folder-opened"></i> Все документы</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group v-for="item in getDocumentsList('VAGONNIK')" :key="item.key">
              <el-menu-item :index="`/company/documents/${item.key}?bin=19114002534511`"><i class="el-icon-document"></i> {{ item.title }} <span v-if="countForKey(item.key) > 0" class="menu-badge">{{ countForKey(item.key) }}</span></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-submenu>

        <el-submenu v-if="isPtc && canWatchDocuments && isActiveCompany('ertys')" index="ertys">
          <template slot="title">
            <i class="el-icon-office-building"></i>
            <span>ТОО “Ертыс-сервис”</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/company/register?type=reestrVC"><i class="el-icon-notebook-2"></i> Реестр с расчетами</el-menu-item>
          </el-menu-item-group>
          <el-submenu index="ertys1">
            <template slot="title">
              <i class="el-icon-download"></i>
              <span>Полученные</span>
              <span v-if="!isMenuOpen('ertys1') && countForKeys(getDocumentsList('ERTYS')) > 0" class="menu-badge">{{ countForKeys(getDocumentsList('ERTYS')) }}</span>
            </template>
            <el-menu-item-group>
              <el-menu-item :index="`/company/documents/${getDocumentsList('ERTYS').map(item => item.key).toString()}?bin=1911400253455&all=1`"><i class="el-icon-folder-opened"></i> Все документы</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group v-for="item in getDocumentsList('ERTYS')" :key="item.key">
              <el-menu-item :index="`/company/documents/${item.key}?bin=1911400253455`"><i class="el-icon-document"></i> {{ item.title }} <span v-if="countForKey(item.key) > 0" class="menu-badge">{{ countForKey(item.key) }}</span></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="ertys2">
            <template slot="title">
              <i class="el-icon-upload2"></i>
              <span>Отправленные</span>
              <span v-if="!isMenuOpen('ertys2') && countForKeys(getTicketsList('ERTYS')) > 0" class="menu-badge">{{ countForKeys(getTicketsList('ERTYS')) }}</span>
            </template>
            <el-menu-item-group>
              <el-menu-item :index="`/company/documents/${getTicketsList('ERTYS').map(item => item.key).toString()}?bin=1911400253455&all=1`"><i class="el-icon-folder-opened"></i> Все документы</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group v-for="item in getTicketsList('ERTYS')" :key="item.key">
              <el-menu-item :index="`/company/documents/${item.key}?bin=1911400253455`"><i class="el-icon-document"></i> {{ item.title }} <span v-if="countForKey(item.key) > 0" class="menu-badge">{{ countForKey(item.key) }}</span></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-submenu>
        <el-submenu v-if="isPtc && canWatchDocuments && isActiveCompany('ertys')" index="ertysArchive">
          <template slot="title">
            <i class="el-icon-office-building"></i>
            <span>ТОО “Ертыс-сервис” (Архив)</span>
          </template>
          <el-submenu index="ertys4">
            <template slot="title">
              <i class="el-icon-download"></i>
              <span>Полученные</span>
              <span v-if="!isMenuOpen('ertys4') && (countForKey('vu20') + countForKey('vu19') + countForKey('vu20a') + countForKey('act')) > 0" class="menu-badge">{{ countForKey('vu20') + countForKey('vu19') + countForKey('vu20a') + countForKey('act') }}</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/company/documents/vu20,vu19,vu20a?bin=070240009538&all=1"><i class="el-icon-folder-opened"></i> Все документы</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group>
              <el-menu-item index="/company/documents/vu20?bin=070240009538"><i class="el-icon-document"></i> Ву-20 <span v-if="countForKey('vu20') > 0" class="menu-badge">{{ countForKey('vu20') }}</span></el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group>
              <el-menu-item index="/company/documents/vu20a?bin=070240009538"><i class="el-icon-document"></i> Ву-20а <span v-if="countForKey('vu20a') > 0" class="menu-badge">{{ countForKey('vu20a') }}</span></el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group>
              <el-menu-item index="/company/documents/vu19?bin=070240009538"><i class="el-icon-document"></i> Ву-19 <span v-if="countForKey('vu19') > 0" class="menu-badge">{{ countForKey('vu19') }}</span></el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group>
              <el-menu-item index="/company/documents/act?bin=070240009538"><i class="el-icon-document"></i> Акт <span v-if="countForKey('act') > 0" class="menu-badge">{{ countForKey('act') }}</span></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="ertys5">
            <template slot="title">
              <i class="el-icon-upload2"></i>
              <span>Отправленные</span>
              <span v-if="!isMenuOpen('ertys5') && (countForKey('processing') + countForKey('vrd')) > 0" class="menu-badge">{{ countForKey('processing') + countForKey('vrd') }}</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/company/documents/processing,vrd?bin=070240009538&all=1"><i class="el-icon-folder-opened"></i> Все документы</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group>
              <el-menu-item index="/company/documents/processing?bin=070240009538"><i class="el-icon-document"></i> Заявка на обработку <span v-if="countForKey('processing') > 0" class="menu-badge">{{ countForKey('processing') }}</span></el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group>
              <el-menu-item index="/company/documents/vrd?bin=070240009538"><i class="el-icon-document"></i> Заявка на ВРД <span v-if="countForKey('vrd') > 0" class="menu-badge">{{ countForKey('vrd') }}</span></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-submenu>
        <el-submenu v-if="isPtc && canWatchDocuments && isActiveCompany('kazykurt')" index="kazykurt">
          <template slot="title">
            <i class="el-icon-office-building"></i>
            <span>ТОО “Казыкурт-ЮГ”</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/company/register?type=reestrShymkent"><i class="el-icon-notebook-2"></i> Реестр с расчетами</el-menu-item>
          </el-menu-item-group>
          <el-submenu index="kaz1">
            <template slot="title">
              <i class="el-icon-download"></i>
              <span>Полученные</span>
              <span v-if="!isMenuOpen('kaz1') && countForKeys(getDocumentsList('KAZYKURT')) > 0" class="menu-badge">{{ countForKeys(getDocumentsList('KAZYKURT')) }}</span>
            </template>
            <el-menu-item-group>
              <el-menu-item :index="`/company/documents/${getDocumentsList('KAZYKURT').map(item => item.key).toString()}?bin=1911400253454&all=1`"><i class="el-icon-folder-opened"></i> Все документы</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group v-for="item in getDocumentsList('KAZYKURT')" :key="item.key">
              <el-menu-item :index="`/company/documents/${item.key}?bin=1911400253454`"><i class="el-icon-document"></i> {{ item.title }} <span v-if="countForKey(item.key) > 0" class="menu-badge">{{ countForKey(item.key) }}</span></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="kaz2">
            <template slot="title">
              <i class="el-icon-upload2"></i>
              <span>Отправленные</span>
              <span v-if="!isMenuOpen('kaz2') && countForKeys(getTicketsList('KAZYKURT')) > 0" class="menu-badge">{{ countForKeys(getTicketsList('KAZYKURT')) }}</span>
            </template>
            <el-menu-item-group>
              <el-menu-item :index="`/company/documents/${getTicketsList('KAZYKURT').map(item => item.key).toString()}?bin=1911400253453&all=1`"><i class="el-icon-folder-opened"></i> Все документы</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group v-for="item in getTicketsList('KAZYKURT')" :key="item.key">
              <el-menu-item :index="`/company/documents/${item.key}?bin=1911400253453`"><i class="el-icon-document"></i> {{ item.title }} <span v-if="countForKey(item.key) > 0" class="menu-badge">{{ countForKey(item.key) }}</span></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-submenu>
        <el-submenu v-if="isPtc && canWatchDocuments && isActiveCompany('batys')" index="batys">
          <template slot="title">
            <i class="el-icon-office-building"></i>
            <span>ТОО “Batys Petroleum”</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/company/register?type=reestrBatys"><i class="el-icon-notebook-2"></i> Реестр с расчетами</el-menu-item>
          </el-menu-item-group>
          <el-submenu index="batysRecv">
            <template slot="title">
              <i class="el-icon-download"></i>
              <span>Полученные</span>
              <span v-if="!isMenuOpen('batysRecv') && countForKeys(getDocumentsList('BATYS')) > 0" class="menu-badge">{{ countForKeys(getDocumentsList('BATYS')) }}</span>
            </template>
            <el-menu-item-group>
              <el-menu-item :index="`/company/documents/${getDocumentsList('BATYS').map(item => item.key).toString()}?bin=1911400253453&all=1`"><i class="el-icon-folder-opened"></i> Все документы</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group v-for="item in getDocumentsList('BATYS')" :key="item.key">
              <el-menu-item :index="`/company/documents/${item.key}?bin=1911400253453`"><i class="el-icon-document"></i> {{ item.title }} <span v-if="countForKey(item.key) > 0" class="menu-badge">{{ countForKey(item.key) }}</span></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="batysSent">
            <template slot="title">
              <i class="el-icon-upload2"></i>
              <span>Отправленные</span>
              <span v-if="!isMenuOpen('batysSent') && countForKeys(getTicketsList('BATYS')) > 0" class="menu-badge">{{ countForKeys(getTicketsList('BATYS')) }}</span>
            </template>
            <el-menu-item-group>
              <el-menu-item :index="`/company/documents/${getTicketsList('BATYS').map(item => item.key).toString()}?bin=1911400253453&all=1`"><i class="el-icon-folder-opened"></i> Все документы</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group v-for="item in getTicketsList('BATYS')" :key="item.key">
              <el-menu-item :index="`/company/documents/${item.key}?bin=1911400253453`"><i class="el-icon-document"></i> {{ item.title }} <span v-if="countForKey(item.key) > 0" class="menu-badge">{{ countForKey(item.key) }}</span></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-submenu>
        <el-submenu v-if="isCompanyUserOrAdmin && canWatchDocuments && !isPtc && !isUserBatys" index="documents">
          <template slot="title">
            <i class="el-icon-download"></i>
            <span>Полученные</span>
            <span v-if="!isMenuOpen('documents') && countForKeys(documentsList) > 0" class="menu-badge">{{ countForKeys(documentsList) }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item :index="'/company/documents/' + documentsList.map(item => item.key).toString() + '?all=1'"><i class="el-icon-folder-opened"></i> Все документы</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-for="item in documentsList" :key="item.key">
            <el-menu-item :index="'/company/documents/' + item.key"><i class="el-icon-document"></i> {{ item.title }} <span v-if="countForKey(item.key) > 0" class="menu-badge">{{ countForKey(item.key) }}</span></el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu v-if="isCompanyUserOrAdmin && canWatchTickets && !isPtc" index="ticketsBatys">
          <template slot="title">
            <i class="el-icon-upload2"></i>
            <span>Отправленные</span>
            <span v-if="!isMenuOpen('ticketsBatys') && countForKeys(ticketList) > 0" class="menu-badge">{{ countForKeys(ticketList) }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item :index="'/company/documents/' + ticketList.map(item => item.key).toString() + '?all=1'"><i class="el-icon-folder-opened"></i> Все документы</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-for="item in ticketList" :key="item.key">
            <el-menu-item :index="'/company/documents/' + item.key"><i class="el-icon-document"></i> {{ item.title }} <span v-if="countForKey(item.key) > 0" class="menu-badge">{{ countForKey(item.key) }}</span></el-menu-item>
          </el-menu-item-group>
        </el-submenu>

        <el-submenu v-if="isCompanyUserOrAdmin && canWatchDocuments && isUserBatys && !isPtc" index="batysDocs">
          <template slot="title">
            <i class="el-icon-download"></i>
            <span>Полученные</span>
            <span v-if="!isMenuOpen('batysDocs') && (countForKeys(getDocumentsList('BATYS')) + countForKeys(getDocumentsList('VAGONNIK'))) > 0" class="menu-badge">{{ countForKeys(getDocumentsList('BATYS')) + countForKeys(getDocumentsList('VAGONNIK')) }}</span>
          </template>
          <el-submenu index="batysDocs1">
            <template slot="title">
              <i class="el-icon-office-building"></i>
              <span>Batys Petroleum</span>
              <span v-if="!isMenuOpen('batysDocs1') && countForKeys(getDocumentsList('BATYS')) > 0" class="menu-badge">{{ countForKeys(getDocumentsList('BATYS')) }}</span>
            </template>
            <el-menu-item-group>
              <el-menu-item :index="`/company/documents/${getDocumentsList('BATYS').map(item => item.key).toString()}?bin=1911400253453&all=1`"><i class="el-icon-folder-opened"></i> Все документы</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group v-for="item in getDocumentsList('BATYS')" :key="item.key">
              <el-menu-item :index="`/company/documents/${item.key}?bin=1911400253453`"><i class="el-icon-document"></i> {{ item.title }} <span v-if="countForKey(item.key) > 0" class="menu-badge">{{ countForKey(item.key) }}</span></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="vagonnikDocs1">
            <template slot="title">
              <i class="el-icon-office-building"></i>
              <span>РТИ-АНПЗ Вагонники</span>
              <span v-if="!isMenuOpen('vagonnikDocs1') && countForKeys(getDocumentsList('VAGONNIK')) > 0" class="menu-badge">{{ countForKeys(getDocumentsList('VAGONNIK')) }}</span>
            </template>
            <el-menu-item-group>
              <el-menu-item :index="`/company/documents/${getDocumentsList('VAGONNIK').map(item => item.key).toString()}?bin=19114002534511&all=1`"><i class="el-icon-folder-opened"></i> Все документы</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group v-for="item in getDocumentsList('VAGONNIK')" :key="item.key">
              <el-menu-item :index="`/company/documents/${item.key}?bin=19114002534511`"><i class="el-icon-document"></i> {{ item.title }} <span v-if="countForKey(item.key) > 0" class="menu-badge">{{ countForKey(item.key) }}</span></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-submenu>
      </el-menu>
      <div v-if="!isMobile" class="user-box">
        <div class="user-box__avatar">{{ initials }}</div>
        <div class="user-box__info">
          <div class="user-box__fio">{{ getFio }}</div>
          <div class="user-box__company">{{ companyDisplayName }}</div>
        </div>
        <router-link to="/login-page" class="user-box__logout" title="Выйти">
          <i class="el-icon-switch-button"></i>
        </router-link>
      </div>
      <router-link v-else to="/login-page" class="user-box__logout-mobile">Выйти</router-link>
    </el-aside>
</template>

<script>
import authorizationAPI from '@/modules/api/authorization'
import {
  canWatchTickets,
  canWatchDocuments,
  canWatchAgreement,
  getDocumentsList, getTicketsList
} from '@/modules/permissions/permissions'
import documentNotificationsStore from '@/modules/notifications/documentNotificationsStore'
export default {
  props: {
    showMenu: Boolean
  },
  data () {
    return {
      isMenuVisible: false,
      isMobile: false,
      menu: [],
      documentsList: [],
      ticketList: [],
      companySwitchOpen: false,
      activeCompanyKey: null,
      openedMenus: []
    }
  },
  mounted () {
    this.checkScreenSize()
    window.addEventListener('resize', this.checkScreenSize)
    this.initNavigationByRole()
    if (this.isPtc) {
      this.activeCompanyKey = 'kazykurt'
      this.$nextTick(() => {
        if (this.$refs.sideMenu) {
          this.$refs.sideMenu.open('kazykurt')
        }
      })
    }
    documentNotificationsStore.startPolling()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.checkScreenSize)
    documentNotificationsStore.stopPolling()
  },
  computed: {
    isCollapse () {
      return this.isMobile // Если мобильное устройство, меню будет свернуто
    },
    getFio () {
      return authorizationAPI.getFio()
    },
    companyDisplayName () {
      return authorizationAPI.getCompanyDisplayName()
    },
    companies () {
      return [
        { key: 'petroleum', label: 'Petroleum', submenu: null },
        { key: 'rti', label: 'РТИ-АНПЗ', submenu: 'vagonnik' },
        { key: 'batys', label: 'Batys Petroleum', submenu: 'batys' },
        { key: 'kazykurt', label: 'Казыкурт-Юг', submenu: 'kazykurt' },
        { key: 'ertys', label: 'Ертыс Сервис', submenu: 'ertys' }
      ]
    },
    activeCompanyLabel () {
      if (!this.isPtc) {
        return this.companyDisplayName
      }
      const active = this.companies.find(c => c.key === this.activeCompanyKey)
      return active ? active.label : 'Выберите компанию'
    },
    initials () {
      const fio = authorizationAPI.getFio() || ''
      const letters = fio.trim().split(/\s+/).map(part => part.charAt(0)).filter(Boolean)
      return letters.slice(0, 2).join('').toUpperCase()
    },
    isPtc () {
      return authorizationAPI.isRolePtc()
    },
    isUserTTK () {
      return authorizationAPI.isUserTTK()
    },
    isUserPortocom () {
      return authorizationAPI.isUserPortocom()
    },
    isUserBatys () {
      return authorizationAPI.isRoleBatys()
    },
    isUserErtys () {
      return authorizationAPI.isRoleErtys()
    },
    isRolePot () {
      return authorizationAPI.isRolePot()
    },
    isUserKazykurt () {
      return authorizationAPI.isRoleKazykurt()
    },
    isRolePetroleum () {
      return authorizationAPI.isRolePetroleum()
    },
    isCompanyUserOrAdmin () {
      return !authorizationAPI.isRoleSuperAdmin()
    },
    canWatchTickets () {
      return canWatchTickets(authorizationAPI.getRole())
    },
    canWatchDocuments () {
      return canWatchDocuments(authorizationAPI.getRole())
    },
    canWatchAgreement () {
      return canWatchAgreement(authorizationAPI.getRole())
    }
  },
  methods: {
    checkScreenSize () {
      this.isMobile = window.innerWidth <= 768
      if (!this.isMobile) {
        this.isMenuVisible = true // Показывать меню на больших экранах
      } else {
        this.isMenuVisible = false // Прятать меню на мобильных
      }
    },
    initNavigationByRole () {
      if (authorizationAPI.isRoleSuperAdmin()) {
        this.menu = [
          {
            index: '/super/documents',
            icon: 'el-icon-document',
            title: 'Документы'
          },
          {
            index: '/super/services',
            icon: 'el-icon-s-tools',
            title: 'Сервисы'
          },
          {
            index: '/super/users',
            icon: 'el-icon-user-solid',
            title: 'Пользователи'
          }
        ]
      } else if (authorizationAPI.isRoleCompanyAdmin()) {
        this.menu = [
          {
            index: '/company/checkSign',
            icon: 'el-icon-s-check',
            title: 'Проверка подписи'
          },
          {
            index: '/company/users',
            icon: 'el-icon-user-solid',
            title: 'Пользователи'
          }
        ]
      } else if (authorizationAPI.isRoleUser()) {
        this.menu = [
          {
            index: '/company/checkSign',
            icon: 'el-icon-s-check',
            title: 'Проверка подписи'
          }
          // {
          //   index: '/company/sign-upload',
          //   icon: 'el-icon-edit-outline',
          //   title: 'Файл для подписи'
          // }
        ]
      }
      // if (this.isPtc) {
      //   this.menu.push({
      //     index: '/company/print-download',
      //     icon: 'el-icon-download',
      //     title: 'Скачать печ. формы'
      //   })
      // }
      this.menu.push({
        index: '/company/print-download',
        icon: 'el-icon-printer',
        title: 'Скачать печ. формы'
      })
      if (this.isUserBatys) {
        this.documentsList = getDocumentsList('BATYS')
        this.ticketList = getTicketsList('BATYS')
        if (authorizationAPI.isRoleBatysBtg()) {
          this.documentsList = getDocumentsList('BTG')
          this.ticketList = getTicketsList('BTG')
        }
      }
      if (this.isUserErtys) {
        this.documentsList = getDocumentsList('ERTYS')
        if (this.isRolePot) {
          this.documentsList = this.documentsList.filter(item => item.key === 'vu20a,vu20' || item.key === 'du1Marking')
        } else {
          this.documentsList = this.documentsList.filter(item => item.key !== 'du1Marking')
        }
        this.ticketList = getTicketsList('ERTYS')
      }
      if (this.isUserKazykurt) {
        this.documentsList = getDocumentsList('KAZYKURT')
        this.ticketList = getTicketsList('KAZYKURT')
      }
    },
    getDocumentsList (station) {
      return getDocumentsList(station)
    },
    getTicketsList (station) {
      return getTicketsList(station)
    },
    handleMenuOpen (index) {
      if (!this.openedMenus.includes(index)) {
        this.openedMenus.push(index)
      }
    },
    handleMenuClose (index) {
      this.openedMenus = this.openedMenus.filter(i => i !== index)
    },
    isMenuOpen (index) {
      return this.openedMenus.includes(index)
    },
    countForKey (key) {
      return documentNotificationsStore.countForType(key)
    },
    countForKeys (list) {
      return documentNotificationsStore.countForTypes((list || []).map(item => item.key))
    },
    isActiveCompany (key) {
      return this.activeCompanyKey === key
    },
    selectCompany (company) {
      if (!company.submenu) return
      this.activeCompanyKey = company.key
      this.companySwitchOpen = false
      this.$nextTick(() => {
        if (this.$refs.sideMenu) {
          this.$refs.sideMenu.open(company.submenu)
        }
      })
    }
  }
}
</script>

<style>
.aside {
  background-color: #1B222C;
  width: 250px !important;
  flex: 0 0 250px;
  transition: width 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  position: sticky;
  top: 0;
}

.aside--collapsed {
  width: 60px !important;
  flex-basis: 60px;
}

.el-menu {
  background-color: transparent !important;
  border-right: none !important;
}

.aside > .el-menu {
  flex: 1 1 auto;
  overflow-y: scroll;
  overflow-x: hidden;
  min-height: 0 !important;
  scrollbar-gutter: stable;
  scrollbar-width: thin;
  scrollbar-color: #333f4e transparent;
}

.aside > .el-menu::-webkit-scrollbar {
  width: 6px;
}

.aside > .el-menu::-webkit-scrollbar-track {
  background: transparent;
}

.aside > .el-menu::-webkit-scrollbar-thumb {
  background-color: #333f4e;
  border-radius: 3px;
}

.aside > .el-menu::-webkit-scrollbar-thumb:hover {
  background-color: #445064;
}

/* logo */
.logo-nav {
  padding: 24px 20px 12px;
  color: #fff;
  font-size: 14px;
}
.logo-nav__title {
  font-size: 11px;
  letter-spacing: 0.08em;
  color: #C7D0DA;
}
.logo-nav__brand {
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #fff;
}
.logo-nav__dot {
  color: #E3A32A;
}

/* company switcher */
.company-switch {
  padding: 0 20px 16px;
  position: relative;
}
.company-switch__label {
  font-size: 10px;
  letter-spacing: 0.08em;
  color: #7A8794;
  margin-bottom: 6px;
}
.company-switch__box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #232D3A;
  border: 1px solid #2c3646;
  border-radius: 8px;
  padding: 8px 10px;
  color: #fff;
  font-size: 13px;
}
.company-switch__value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.company-switch__box i {
  color: #7A8794;
  margin-left: 6px;
}
.company-switch__box--clickable {
  cursor: pointer;
}
.company-switch__box--clickable:hover {
  border-color: #E3A32A;
}
.company-switch__list {
  position: absolute;
  left: 20px;
  right: 20px;
  top: 100%;
  z-index: 20;
  background: #232D3A;
  border: 1px solid #2c3646;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.35);
}
.company-switch__item {
  padding: 9px 12px;
  font-size: 13px;
  color: #C7D0DA;
  cursor: pointer;
}
.company-switch__item:hover {
  background: #1B222C;
  color: #fff;
}
.company-switch__item--active {
  color: #E3A32A;
}
.company-switch__item--disabled {
  color: #4a5568;
  cursor: not-allowed;
}
.company-switch__item--disabled:hover {
  background: transparent;
  color: #4a5568;
}

.menu-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 6px;
  margin-left: 8px;
  border-radius: 10px;
  background: #E3A32A;
  color: #1B222C;
  font-size: 11px;
  font-weight: 700;
  line-height: 18px;
}

/* section labels */
.menu-section-label {
  padding: 14px 20px 6px;
  font-size: 10px;
  letter-spacing: 0.08em;
  color: #7A8794;
  text-transform: uppercase;
}

.el-submenu .el-menu-item {
  font-size: 14px;
  padding: 0 0 0 20px !important;
  color: #C7D0DA;
}
.el-menu-item-group__title {
  padding: 0 !important;
}

.el-menu-item {
  white-space: normal !important;
  height: auto !important;
  min-height: 36px;
  line-height: 20px !important;
  margin: 2px 0;
  display: flex;
  align-items: center;
  color: #C7D0DA !important;
  padding-left: 20px !important;
  border-left: 3px solid transparent;
}

.el-menu-item i {
  color: #7A8794 !important;
  margin-right: 8px;
}

.el-submenu__title {
  color: #C7D0DA !important;
  padding-left: 20px !important;
  height: 40px;
  line-height: 40px;
}
.el-submenu__title i {
  color: #7A8794;
}

.el-menu-item:hover, .el-submenu__title:hover {
  background-color: #232D3A !important;
  color: #fff !important;
}

.el-menu-item.is-active {
  background-color: #232D3A !important;
  color: #fff !important;
  border-left-color: #E3A32A;
}

.el-submenu.is-opened > .el-submenu__title {
  color: #fff !important;
}

/* user block */
.user-box {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  border-top: 1px solid #232D3A;
}
.user-box__avatar {
  width: 34px;
  height: 34px;
  min-width: 34px;
  border-radius: 50%;
  background: #E3A32A;
  color: #1B222C;
  font-weight: 700;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.user-box__info {
  flex: 1;
  overflow: hidden;
}
.user-box__fio {
  color: #fff;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.user-box__company {
  color: #7A8794;
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.user-box__logout {
  color: #7A8794;
  font-size: 18px;
}
.user-box__logout:hover {
  color: #E3A32A;
}
.user-box__logout-mobile {
  display: block;
  text-align: center;
  padding: 10px;
  color: #C7D0DA;
}
</style>
